module.exports = __webpack_public_path__ + "00df7a01b711639fd11cb1aa8747f7d5.svg";